module.exports = __webpack_public_path__ + "img/hidden.6af89bfc.svg";